import { render, staticRenderFns } from "./CategoryTreeItem.vue?vue&type=template&id=88d8afac&scoped=true"
import script from "./CategoryTreeItem.vue?vue&type=script&lang=js"
export * from "./CategoryTreeItem.vue?vue&type=script&lang=js"
import style0 from "./CategoryTreeItem.vue?vue&type=style&index=0&id=88d8afac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d8afac",
  null
  
)

export default component.exports